import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import logoImage from '@assets/images/logo_L.png'
import ChangePasswordForm from './components/ChangePasswordForm'
import { LoadingOverlay } from '@/components/LoadingOverlay'
import Footer from '@/components/Footer'
import { auth } from '@/config/firebase'
import { useSchoolAccount } from '@/context/SchoolAccountContext'

function FirstLogin() {
  const navigate = useNavigate()
  const { schoolAccount, isLoading: schoolAccountLoading } = useSchoolAccount()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (schoolAccountLoading) return
    const user = auth.currentUser
    if (!user) {
      navigate('/login', { replace: true })
      return
    }
    if (schoolAccount && schoolAccount.lastLoginAt) {
      navigate('/dashboards', { replace: true })
    }
  }, [schoolAccount, schoolAccountLoading, navigate])

  if (schoolAccountLoading) {
    return <LoadingOverlay show />
  }

  if (!auth.currentUser || (schoolAccount && schoolAccount.lastLoginAt)) {
    return null
  }

  return (
    <div className="auth-page-shell">
      <div className="login-container">
        <LoadingOverlay show={isLoading} />
        <div className="login-card">
          <img src={logoImage} alt="IROGAMI" className="login-logo" />
          <h2 className="change-password-title">
            初回ログインのため、<br></br>パスワードを変更してください。
          </h2>
          <ChangePasswordForm onLoadingChange={setIsLoading} />
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default FirstLogin
